export default "__VITE_ASSET__9TM5jk_p__"